module.exports = __webpack_public_path__ + "img/item-2.7427e4af.png";